import { ModuleWithProviders, NgModule } from '@angular/core';
import { ModelsBrowseStoreConfig } from '@ddt-web/models-browsing';
import { applicationStateReducer } from '@ddt-web/shared-stores';
import { createReducerWithConfig, StoreServiceModule } from '@ddt-web/store-service';
import { EffectsModule } from '@ngrx/effects';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export function familiesReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.families)(state, action);
}

export function familyOverviewReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.familyOverview)(state, action);
}

export function filterConfigReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.filterConfig)(state, action);
}

export function familyPerformanceReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.familyPerformance)(state, action);
}
export function familyHoldingsReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.familyHoldings)(state, action);
}
export function reportConfigReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.reportConfig)(state, action);
}

export function positionDetailsReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.positionDetails)(state, action);
}

export function familyEsgReducer(state, action): ActionReducer<any, Action> {
	return createReducerWithConfig(ModelsBrowseStoreConfig.familyEsg)(state, action);
}

@NgModule({
	imports: [
		StoreModule.forRoot(
			{
				applicationState: applicationStateReducer,
				families: familiesReducer,
				familyEsg: familyEsgReducer,
				familyHoldings: familyHoldingsReducer,
				familyOverview: familyOverviewReducer,
				familyPerformance: familyPerformanceReducer,
				filterConfig: filterConfigReducer,
				positionDetails: positionDetailsReducer,
				reportConfig: reportConfigReducer
			},
			{
				runtimeChecks: {
					strictActionImmutability: true,
					strictStateImmutability: true
				}
			}
		),
		EffectsModule.forRoot([
			// Add effects here
		]),
		StoreDevtoolsModule.instrument({
			maxAge: 25 // Retains last 25 states
		}),
		StoreServiceModule.forRoot()
	]
})
export class AppStoreModule {
	public static forRoot(): ModuleWithProviders<AppStoreModule> {
		return {
			ngModule: AppStoreModule,
			providers: []
		};
	}
}
